@if (report() && skills().length > 0) {
	<div>
		<div class="title">Student Reports</div>
		<div class="student-report">
			<app-reporting-table [loading]="loading()" [rows]="report()!.students" [columns]="columns()">
				<!-- Header templates -->
				<ng-template appHeaderColumn="studentName">Student Name</ng-template>
				@for (skill of skills(); track skill) {
					<ng-template [appHeaderColumn]="skill">{{ skill | titlecase }}</ng-template>
				}

				<!-- Cell templates -->
				<ng-template appRowColumn="studentName" let-row>
					<div
						class="student-name"
						[nz-tooltip]="row.studentName || '...'"
						(click)="selectStudent(row.studentUuid)"
					>
						{{ row.studentName || '...' }}
					</div>
					@for (skill of skills(); track skill) {
						<div [ngClass]="[skill]"></div>
					}
				</ng-template>

				@for (skill of skills(); track skill) {
					<ng-template [appRowColumn]="skill" let-row>
						<div class="student-row">
							<div class="{{ skill }}">
								<div
									class="color-bar"
									[class.level1]="row.skills[skill] >= 0 && row.skills[skill] <= 1"
									[class.level2]="row.skills[skill] > 1 && row.skills[skill] <= 2"
									[class.level3]="row.skills[skill] > 2 && row.skills[skill] <= 3"
									[class.level4]="row.skills[skill] > 3 && row.skills[skill] <= 4"
									[class.level5]="row.skills[skill] > 4 && row.skills[skill] <= 5"
									[class.level6]="row.skills[skill] > 5 && row.skills[skill] <= MAX_LEVEL()"
								></div>
								<div class="level">{{ row.skills[skill] || 0 }}</div>
								<div class="percentage-bar">
									<div
										class="bg"
										[class.level1]="row.skills[skill] >= 0 && row.skills[skill] <= 1"
										[class.level2]="row.skills[skill] > 1 && row.skills[skill] <= 2"
										[class.level3]="row.skills[skill] > 2 && row.skills[skill] <= 3"
										[class.level4]="row.skills[skill] > 3 && row.skills[skill] <= 4"
										[class.level5]="row.skills[skill] > 4 && row.skills[skill] <= 5"
										[class.level6]="row.skills[skill] > 5 && row.skills[skill] <= MAX_LEVEL()"
										[style.width]="
											row.skills[skill] <= 0 || row.skills[skill] > MAX_LEVEL()
												? '6px'
												: (row.skills[skill] / MAX_LEVEL()) * 100 + '%'
										"
									></div>
								</div>
							</div>
						</div>
					</ng-template>
				}
			</app-reporting-table>
		</div>
	</div>
}
